<script setup lang="ts">
import { ref, onMounted } from 'vue';
import ChatWindow from '@/views/communication/components/ChatWindow.vue';
import useConversationsStore from '@/stores/communication/conversations';
import ConversationList from '@/views/communication/components/ConversationList.vue';
import CreateConversationModal from '@/views/communication/components/CreateConversationModal.vue';
import useChatStore from '@/stores/communication/chat';

const chatStore = useChatStore();

const conversationsStore = useConversationsStore();

const showCreate = ref(false);
const activeUuid = ref<string | null>(null);
const displayName = ref<string | null>(null);

onMounted(() => {
	conversationsStore.fetchConversations();
});

// open conversation in right pane and update URL
function openConversation(uuid: string, display_name?: string) {
	chatStore.loading = true;
	activeUuid.value = uuid;
	displayName.value = display_name || null;
	window.history.pushState({}, '', `/communication/${uuid}`);
}

function onConversationCreated(conv: any) {
	conversationsStore.fetchConversations();
	openConversation(conv.uuid, conv.display_name);
	showCreate.value = false;
}

// if route param present, open conversation
import { useRoute } from 'vue-router';
const route = useRoute();
if (route.params.uuid) {
	activeUuid.value = String(route.params.uuid);
}
</script>

<template>
	<v-container fluid>
		<v-row>
			<v-col cols="4" class="pa-2">
				<v-card variant="elevated" class="fill-height">
					<v-card-title class="d-flex align-center">
						Conversations
						<v-spacer />
						<v-btn
							prepend-icon="mdi-refresh"
							variant="plain"
							@click="conversationsStore.fetchConversations"
							>Refresh</v-btn
						>
						<v-btn
							prepend-icon="mdi-message-processing"
							color="teal"
							@click="showCreate = true"
							class="ml-2"
							variant="plain"
							>New</v-btn
						>
					</v-card-title>

					<v-divider />

					<ConversationList
						:conversations="conversationsStore.conversations"
						:loading="conversationsStore.loading"
						@open="openConversation"
					/>
				</v-card>
			</v-col>

			<v-col cols="8" class="pa-2">
				<v-card class="fill-height">
					<template v-if="activeUuid">
						<ChatWindow :uuid="activeUuid" :display-name="displayName" />
					</template>
					<template v-else>
						<v-card-text class="text-center text-h7"
							>Select a conversation or create one.</v-card-text
						>
					</template>
				</v-card>
			</v-col>
		</v-row>

		<CreateConversationModal
			v-model:show="showCreate"
			@created="onConversationCreated"
		/>
	</v-container>
</template>
